import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './PriceItem.module.css';

export interface PriceItemProps {
    price: string;
    originalPrice?: string;
    className?: string;
}

export const PriceItem: FunctionComponent<PriceItemProps> = props => {
    return (
        <span className={clsx(styles.price, props.className)}>
            {props.originalPrice !== undefined && props.originalPrice !== props.price ? (
                <span className={styles.originalPrice}>{`$${props.originalPrice}`}</span>
            ) : null}
            {`$${props.price}`}
        </span>
    );
};

export default PriceItem;
